import {
  Flame,
  Gamepad2,
  CreditCard,
  Shield,
  DollarSign,
  BookOpen,
  Gift,
  Smartphone,
} from "lucide-react";

// Import images from local folder
import rakutenImg from "../images/Rakuten - $40 Bonus.png";
import coinMasterImg from "../images/Coin Master - $50 Reward.png";
import chimeImg from "../images/Chime - $100 Bank Bonus.png";
import userTestingImg from "../images/UserTesting - $10 Per Test.png";
import candyCrushImg from "../images/Candy Crush Saga.png"; // Note: Candy Crush was missing from list_dir, using placeholder if needed or assuming same pattern
import pokemonGoImg from "../images/Pokémon GO.png";
import robloxImg from "../images/Roblox - Build & Play.png";
import clashRoyaleImg from "../images/Clash Royale.png";
import lordsMobileImg from "../images/Lords Mobile.png";
import stateOfSurvivalImg from "../images/State of Survival.png";
import nordVpnImg from "../images/NordVPN - 30 Day Free Trial.png";
import expressVpnImg from "../images/ExpressVPN - 30 Days Free.png";
import surfsharkImg from "../images/Surfshark VPN.png";
import swagbucksImg from "../images/Swagbucks - Earn $5.png";
import surveyJunkieImg from "../images/Survey Junkie.png";
import prolificImg from "../images/Prolific - Academic Surveys.png";
import inboxDollarsImg from "../images/InboxDollars - $5 Bonus.png";
import ibottaImg from "../images/Ibotta - Grocery Cashback.png";
import fetchImg from "../images/Fetch Rewards.png";
import doordashImg from "../images/DoorDash Driver - First Order $5.png";
import uberEatsImg from "../images/Uber Eats Driver.png";
import airbnbImg from "../images/Airbnb Host Bonus.png";
import appleGiftCardImg from "../images/Apple Gift Card.png";
import googlePlayImg from "../images/Google Play Credit.png";
import youtubePremiumImg from "../images/YouTube Premium.png";

const mergeDragonsImg = "/images/Merge Dragons!.png";

export const categories = [
  { id: "trending", label: "Trending", icon: Flame },
  { id: "games", label: "Games", icon: Gamepad2 },
  { id: "gift-cards", label: "Gift Cards", icon: CreditCard },
  { id: "rewards", label: "Rewards", icon: Gift },
  { id: "apps", label: "Apps", icon: Smartphone },
  { id: "vpns", label: "VPNs", icon: Shield },
  { id: "finance", label: "Finance", icon: DollarSign },
  { id: "hot", label: "Hot", icon: Flame },
  { id: "guides", label: "Guides", icon: BookOpen },
];

export const featuredOffers = [
  {
    id: "rakuten-cashback",
    title: "Rakuten - $40 Bonus",
    subtitle: "Sign up and start earning cashback on every purchase.",
    category: "Rewards",
    image: rakutenImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "CLAIM BONUS",
    payout: 40,
    route: "/offer/rakuten-cashback",
    color: "bg-red-600",
  },
  {
    id: "coin-master",
    title: "Coin Master - $50 Reward",
    subtitle: "Reach Level 30 and spin the wheel.",
    category: "Games",
    image: coinMasterImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "PLAY NOW",
    payout: 50,
    route: "/offer/coin-master",
    color: "bg-yellow-500",
  },
  {
    id: "chime-banking",
    title: "Chime - $100 Bank Bonus",
    subtitle: "Open account & set up direct deposit.",
    category: "Finance",
    image: chimeImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "CLAIM $100",
    payout: 100,
    route: "/offer/chime-banking",
    color: "bg-green-600",
  },
  {
    id: "usertest-surveys",
    title: "UserTesting - $10 Per Test",
    subtitle: "Complete user testing surveys and earn instantly.",
    category: "Rewards",
    image: userTestingImg,
    badge: "LIMITED",
    badgeType: "LIMITED",
    ctaLabel: "START EARNING",
    payout: 25,
    route: "/offer/usertest-surveys",
    color: "bg-purple-600",
  },
];

export const gameOffers = [
  {
    id: "candy-crush",
    title: "Candy Crush Saga",
    subtitle: "Reach Level 50 in the puzzle game",
    category: "Games",
    image: candyCrushImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "PLAY",
    payout: 25,
    route: "/offer/candy-crush",
  },
  {
    id: "pokemon-go",
    title: "Pokémon GO",
    subtitle: "Catch 20 different Pokémon",
    category: "Games",
    image: pokemonGoImg,
    badge: "NEW",
    badgeType: "NEW",
    ctaLabel: "DOWNLOAD",
    payout: 35,
    route: "/offer/pokemon-go",
  },
  {
    id: "roblox",
    title: "Roblox - Build & Play",
    subtitle: "Join & complete 3 games",
    category: "Games",
    image: robloxImg,
    ctaLabel: "PLAY",
    payout: 30,
    route: "/offer/roblox",
  },
  {
    id: "clash-royale",
    title: "Clash Royale",
    subtitle: "Reach Arena 7 in battle",
    category: "Games",
    image: clashRoyaleImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "PLAY",
    payout: 28,
    route: "/offer/clash-royale",
  },
  {
    id: "lords-mobile",
    title: "Lords Mobile",
    subtitle: "Build your kingdom to Level 12",
    category: "Games",
    image: lordsMobileImg,
    ctaLabel: "PLAY",
    payout: 45,
    route: "/offer/lords-mobile",
  },
  {
    id: "state-of-survival",
    title: "State of Survival",
    subtitle: "Reach Command Center Level 15",
    category: "Games",
    image: stateOfSurvivalImg,
    ctaLabel: "PLAY",
    payout: 50,
    route: "/offer/state-of-survival",
  },
  {
    id: "merge-dragons",
    title: "Merge Dragons!",
    subtitle: "Complete 5 levels and merge dragons",
    category: "Games",
    image: mergeDragonsImg,
    ctaLabel: "PLAY",
    payout: 22,
    route: "/offer/merge-dragons",
  },
];

// Additional offer categories
export const vpnOffers = [
  {
    id: "nordvpn",
    title: "NordVPN - 30 Day Free Trial",
    subtitle: "Secure & anonymous browsing",
    category: "VPNs",
    image: nordVpnImg,
    badge: "TRIAL",
    badgeType: "TRIAL",
    ctaLabel: "START TRIAL",
    payout: 18,
    route: "/offer/nordvpn",
  },
  {
    id: "expressvpn",
    title: "ExpressVPN - 30 Days Free",
    subtitle: "Ultra-fast VPN service",
    category: "VPNs",
    image: expressVpnImg,
    ctaLabel: "GET FREE",
    payout: 22,
    route: "/offer/expressvpn",
  },
  {
    id: "surfshark",
    title: "Surfshark VPN",
    subtitle: "Unlimited simultaneous connections",
    category: "VPNs",
    image: surfsharkImg,
    ctaLabel: "TRY FREE",
    payout: 16,
    route: "/offer/surfshark",
  },
];

export const surveyOffers = [
  {
    id: "swagbucks",
    title: "Swagbucks - Earn $5",
    subtitle: "Complete surveys, watch videos & shop",
    category: "Rewards",
    image: swagbucksImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "START EARNING",
    payout: 5,
    route: "/offer/swagbucks",
  },
  {
    id: "survey-junkie",
    title: "Survey Junkie",
    subtitle: "Get paid for your opinions",
    category: "Rewards",
    image: surveyJunkieImg,
    ctaLabel: "JOIN FREE",
    payout: 3,
    route: "/offer/survey-junkie",
  },
  {
    id: "prolific",
    title: "Prolific - Academic Surveys",
    subtitle: "Earn £5-15+ per study",
    category: "Rewards",
    image: prolificImg,
    badge: "NEW",
    badgeType: "NEW",
    ctaLabel: "REGISTER",
    payout: 8,
    route: "/offer/prolific",
  },
  {
    id: "inboxdollars",
    title: "InboxDollars - $5 Bonus",
    subtitle: "Read emails, take surveys, play games",
    category: "Rewards",
    image: inboxDollarsImg,
    ctaLabel: "CLAIM $5",
    payout: 5,
    route: "/offer/inboxdollars",
  },
];

export const appOffers = [
  {
    id: "ibotta",
    title: "Ibotta - Grocery Cashback",
    subtitle: "Scan receipts & earn cash back",
    category: "Apps",
    image: ibottaImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "DOWNLOAD",
    payout: 12,
    route: "/offer/ibotta",
  },
  {
    id: "fetch",
    title: "Fetch Rewards",
    subtitle: "Scan receipts for points",
    category: "Apps",
    image: fetchImg,
    ctaLabel: "DOWNLOAD",
    payout: 10,
    route: "/offer/fetch",
  },
  {
    id: "doordash",
    title: "DoorDash Driver - First Order $5",
    subtitle: "Sign up as driver and earn",
    category: "Apps",
    image: doordashImg,
    ctaLabel: "SIGN UP",
    payout: 25,
    route: "/offer/doordash",
  },
  {
    id: "uber-eats",
    title: "Uber Eats Driver",
    subtitle: "Earn $15+ per delivery",
    category: "Apps",
    image: uberEatsImg,
    ctaLabel: "JOIN",
    payout: 20,
    route: "/offer/uber-eats",
  },
  {
    id: "airbnb-host",
    title: "Airbnb Host Bonus",
    subtitle: "List your space & earn up to $100",
    category: "Apps",
    image: airbnbImg,
    badge: "LIMITED",
    badgeType: "LIMITED",
    ctaLabel: "GET BONUS",
    payout: 75,
    route: "/offer/airbnb",
  },
];



export const giftCardOffers = [
  {
    id: "apple-card",
    title: "Apple Gift Card",
    subtitle: "Up to $100 in credits",
    category: "Gift Cards",
    image: appleGiftCardImg,
    ctaLabel: "Claim Offer",
    payout: 100,
    route: "/offer/apple-card",
  },
  {
    id: "google-play",
    title: "Google Play Credit",
    subtitle: "Premium app credits",
    category: "Gift Cards",
    image: googlePlayImg,
    ctaLabel: "Claim Offer",
    payout: 50,
    route: "/offer/google-play",
  },
  {
    id: "youtube",
    title: "YouTube Premium",
    subtitle: "Ad-free experience",
    category: "Gift Cards",
    image: youtubePremiumImg,
    ctaLabel: "Claim Offer",
    payout: 15,
    route: "/offer/youtube",
  },
];

export const tickerMessages = [
  "User4829 just earned $75 with Capital One!",
  "🔥 Coin Master Level 30 completed - $50 paid!",
  "Survey completed! User received $8 bonus!",
  "New Pokemon GO offer added - Up to $35!",
  "Rakuten cashback: 582 users earned today!",
  "🎮 State of Survival Commander Level 15 unlocked!",
  "📱 Ibotta receipt scanned - $5.50 earned!",
  "Chase Sapphire approved - $300 bonus on the way!",
  "Swagbucks video completed - Points added!",
  "Lord's Mobile Kingdom Built - $45 reward paid!",
  "150 users claimed Free Bonus today!",
  "Roblox skins event is LIVE now...",
  "Chime bonus increased to $100 for a limited time!",
];

export const financeOffers = [
  {
    id: "chime-direct",
    title: "Chime - $100 Bank Bonus",
    subtitle: "Open account & set up direct deposit.",
    category: "Finance",
    image: chimeImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "CLAIM $100",
    payout: 100,
    route: "/offer/chime-banking",
    color: "bg-green-600",
  },
  {
    id: "rakuten-bonus",
    title: "Rakuten - $40 Bonus",
    subtitle: "Sign up and start earning cashback.",
    category: "Finance",
    image: rakutenImg,
    badge: "HOT",
    badgeType: "HOT",
    ctaLabel: "CLAIM BONUS",
    payout: 40,
    route: "/offer/rakuten-cashback",
    color: "bg-red-600",
  },
];
